import { Lang } from 'Roblox';
import angular from 'angular';

const dependencies = [
  'robloxApp',
  'ui.router',
  'cursorPagination',
  'premium',
  'systemFeedback',
  'verticalMenu',
  'modal',
  'phoneValidation'
];
const accounts = angular.module('accounts', dependencies).config([
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  'accountConstantsResources',
  'languageResourceProvider',
  (
    $stateProvider,
    $urlRouterProvider,
    $locationProvider,
    accountConstantsResources,
    languageResourceProvider
  ) => {
    // validate url
    const loc = window.location.href;
    if (loc.indexOf('#') != -1 && loc.indexOf('#!') == -1) {
      window.location.href = loc.replace('#', '#!');
    }
    // false mean hashband mode
    $locationProvider.html5Mode(false);
    $locationProvider.hashPrefix('!');
    $urlRouterProvider.otherwise('/info');
    $stateProvider
      .state('info', {
        url: '/info',
        label: 'Account Info',
        templateUrl: accountConstantsResources.templates.accountInfo
      })
      .state('social', {
        url: '/social',
        label: 'Social',
        templateUrl: accountConstantsResources.templates.accountSocial
      })
      .state('security', {
        url: '/security',
        label: 'Security',
        templateUrl: accountConstantsResources.templates.accountSecurity
      })
      .state('privacy', {
        url: '/privacy',
        label: 'Privacy',
        templateUrl: accountConstantsResources.templates.accountPrivacy
      })
      .state('billing', {
        url: '/billing',
        label: 'Billing',
        templateUrl: accountConstantsResources.templates.accountBilling
      })
      .state('notifications', {
        url: '/notifications',
        label: 'Notifications',
        templateUrl: accountConstantsResources.templates.accountNotifications
      })
      .state('fast-track', {
        url: '/fast-track',
        label: 'Fast Track',
        templateUrl: accountConstantsResources.templates.accountFastTrack
      });

    languageResourceProvider.setLanguageKeysFromFile(Lang.AccountSettingsResources);
    languageResourceProvider.setLanguageKeysFromFile(Lang.ControlsResources);
    languageResourceProvider.setLanguageKeysFromFile(Lang['Authentication.Social']);
    languageResourceProvider.setLanguageKeysFromFile(Lang.PremiumResources);
    languageResourceProvider.setLanguageKeysFromFile(Lang.DisplayNameResources);
  }
]);

export default accounts;
